import { useEffect } from 'react'

import { useLocation } from '../core/navigation.hooks'
import { scrollUp } from '../../../utils/scroll'

/**
 * this scroll to top when we change page (like regular routing)
 */
const ScrollRestauration: React.FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    scrollUp()
  }, [pathname])

  return null
}

export default ScrollRestauration
